import PropTypes from 'prop-types';
import ErrorPage from '../../../status-pages/components/ErrorPage';
import ProcessingOrder from '../../../processing-order';
import PendingPaymentDialog from './pending-payment';
import EmptyCartDialog from './EmptyCartDialog';

const PaymentPageErrorDelegate = ({ error, refetch }) => {
  const { message } = error;

  if (message.includes('PENDING_PAYMENT')) {
    return <PendingPaymentDialog refetch={refetch} />;
  }

  if (message.includes('CART_HAS_NO_RESERVATIONS')) {
    return <EmptyCartDialog />;
  }

  const isPendingProvider = message.includes('PENDING_PROVIDER_BOOKING');
  if (message.includes('PROCESSING_ORDER') || isPendingProvider) {
    return (
      <ProcessingOrder isPendingProvider={isPendingProvider} processingOrderMessage={message} />
    );
  }
  return <ErrorPage />;
};

PaymentPageErrorDelegate.propTypes = {
  error: PropTypes.objectOf(PropTypes.any),
  refetch: PropTypes.func,
};

export default PaymentPageErrorDelegate;
